import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import SvgIcon from 'src/components/common/SvgIcon'
import styles from './event-guest-chat-photo-cell.scss'

import {
  invitationsAcceptedCountSelector,
  invitationsCountSelector,
  messageCountSelector,
  processedMediaCountSelector,
  isHostSelector
} from 'src/selectors'

import { androidObject, isHobnobAndroidClient, pluralize } from 'services/utils'
import Button from 'components/common/Button'
import AddIconWhite from 'assets/icons/add-icon-white.png'

import rightChevronSmall from 'src/assets/icons/right_chevron_small.svg'

class EventGuestChatPhotoCell extends React.Component {
  _guestListEnabled() {
    const { isHost } = this.props

    return this.props.event.guest_list_enabled || isHost
  }

  _guestChatEnabled() {
    return this.props.event.commenting_enabled
  }

  _messagePane() {
    const { messageCount } = this.props
    let item = {}
    item.title = 'chat'
    item.text = 'Event Chat'
    item.key = 'comments'
    item.desc = `${messageCount} ${pluralize(messageCount, 'Message')}`

    return item
  }

  _guestsPane() {
    const { invitationsCount, invitationsAcceptedCount } = this.props
    let item = {}
    item.title = 'guests'
    item.text = 'Guest List'
    item.key = 'guests'
    item.desc = `${invitationsCount} Invited`
    if (invitationsAcceptedCount) {
      item.desc = `${item.desc}, ${invitationsAcceptedCount} Attending`
    }

    return item
  }

  _photosPane() {
    const { processedMediaCount } = this.props
    let item = {}
    item.title = 'Photos'
    item.text = 'Photos'
    item.key = 'media'
    item.desc = `${processedMediaCount} ${pluralize(processedMediaCount, 'Photo')}`

    return item
  }

  _renderLabel(panes) {
    let titleList = []
    for (let i = 0; i < panes.length; i++) {
      titleList.push(panes[i].title)
    }
    // let str = titleList.join(', ')
    // let startStr = str.substring(0, str.lastIndexOf(','))
    // let endStr = str.substring(str.lastIndexOf(',') + 1)
    // str = startStr + ' &' + endStr
    let str = titleList.join(',').replace(/,/g, ' & ')

    return str
  }

  onClickCell = (e, pane) => {
    const { onChange, event } = this.props
    if (isHobnobAndroidClient()) {
      if (pane.key === 'comments') {
        androidObject().launchEventChatActivity(event.id)
      } else if (pane.key === 'media') {
        androidObject().launchPhotosActivity(event.id, false, false)
      } else {
        onChange(pane.key)
      }
    } else {
      onChange(pane.key)
    }
  }

  _getPanes() {
    let panes = []
    if (this._guestListEnabled()) {
      panes.push(this._guestsPane())
    }
    if (this._guestChatEnabled()) {
      panes.push(this._messagePane())
    }
    panes.push(this._photosPane())

    return panes
  }

  renderHiddenText(pane) {
    if (pane.key === 'guests' && !this.props.event.guest_list_enabled) {
      return <span className={styles['hidden-text']}>(hidden)</span>
    }
  }

  render() {
    const panes = this._getPanes()
    const { isHost } = this.props

    return (
      <div className={styles['container']}>
        {panes.length >= 1 ? (
          <h3 className={styles['cell-title']}>{this._renderLabel(panes)}</h3>
        ) : null}
        {false && isHost && (
          <div className={styles['add-guest-button']}>
            <Button className={styles['button']}>
              <img src={AddIconWhite} width="16" />
              Add Guest
            </Button>
          </div>
        )}
        <ul>
          {panes.map(pane => (
            <li
              className={styles['cell-item']}
              key={pane.key}
              onClick={event => this.onClickCell(event, pane)}
            >
              <div className={styles['pane-wrap']}>
                <div className={styles['pane-text']}>{pane.text}: {this.renderHiddenText(pane)}</div>
                <div>{pane.desc}</div>
              </div>
              <SvgIcon icon={rightChevronSmall} className={styles['pane-chevron-icon']} />
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

EventGuestChatPhotoCell.propTypes = {
  event: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  messageCount: PropTypes.number,
  processedMediaCount: PropTypes.number,
  invitationsCount: PropTypes.number,
  invitationsAcceptedCount: PropTypes.number,
  isHost: PropTypes.any
}
function mapStateToProps(state) {
  const messageCount = messageCountSelector(state)
  const processedMediaCount = processedMediaCountSelector(state)
  const invitationsCount = invitationsCountSelector(state)
  const invitationsAcceptedCount = invitationsAcceptedCountSelector(state)
  return {
    messageCount,
    processedMediaCount,
    invitationsCount,
    invitationsAcceptedCount,
    isHost: isHostSelector(state)
  }
}
export default connect(mapStateToProps)(EventGuestChatPhotoCell)



// WEBPACK FOOTER //
// ./src/components/details/EventGuestChatPhotoCell.jsx